import {
  CLEAR_LOGS,
  CLEAR_LOGS_FLAGS,
  ERROR_LOGS,
  LIST_LOGS_INIT,
  LIST_LOGS_SUCCESS
} from 'src/redux/actionTypes';
import { ILog } from 'src/integracoes/servicos/pgloader/modelos/ILog';

const INIT_STATE = {
  logs: [] as ILog[],
  loading: false,
  isError: false,
  msg: '',
  success: false
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case LIST_LOGS_INIT:
      return { ...state, loading: true, success: false };
    case LIST_LOGS_SUCCESS:
      return { ...state, loading: false, logs: action.payload, success: true };
    case ERROR_LOGS: {
      const { msg } = action.payload;
      return { ...state, loading: false, msg, isError: true };
    }
    case CLEAR_LOGS:
      return { ...INIT_STATE };
    case CLEAR_LOGS_FLAGS:
      return { ...state, isError: false, msg: '' };
    default:
      return { ...state };
  }
};
